import type { Scene } from '../scenes';

const clock = (cx: number, cy: number, r: number) => (
  <g>
    <circle cx={cx} cy={cy} r={r} fill="#fffdf6" stroke="#3a3a3a" strokeWidth="3" />
    <line x1={cx} y1={cy} x2={cx} y2={cy - r + 6} stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
    <line x1={cx} y1={cy} x2={cx + r / 2} y2={cy + 4} stroke="#3a3a3a" strokeWidth="3" strokeLinecap="round" />
  </g>
);

const bedroom: Scene = {
  id: 'bedroom',
  label: 'Bedroom',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="200" fill="#ebe7f1" />
      <rect y="200" width="400" height="100" fill="#d6bf9b" />
      <g stroke="#c3a982" strokeWidth="1.5">{[222, 246, 272].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}</g>
      <rect y="194" width="400" height="6" fill="#d9d2e2" />
      <rect x="200" y="172" width="50" height="68" fill="#c9a27a" stroke="#9a7550" strokeWidth="2" />
      <line x1="200" y1="204" x2="250" y2="204" stroke="#9a7550" strokeWidth="2" />
      <circle cx="225" cy="190" r="3" fill="#9a7550" />
      <circle cx="225" cy="222" r="3" fill="#9a7550" />
    </>
  ),
  parts: [
    {
      id: 'window', label: 'window', at: [190, 66], box: [148, 26, 84, 80], art: (
        <g>
          <rect x="152" y="30" width="76" height="72" rx="3" fill="#cfe8f7" stroke="#9c8a74" strokeWidth="5" />
          <line x1="190" y1="30" x2="190" y2="102" stroke="#9c8a74" strokeWidth="4" />
          <line x1="152" y1="66" x2="228" y2="66" stroke="#9c8a74" strokeWidth="4" />
        </g>
      ),
    },
    {
      id: 'picture', label: 'picture', at: [70, 64], box: [36, 38, 68, 54], art: (
        <g>
          <rect x="40" y="42" width="60" height="46" fill="#f6efe0" stroke="#8a6a4a" strokeWidth="4" />
          <path d="M44 84 L62 62 L74 74 L82 66 L96 84 Z" fill="#7fae7f" />
          <circle cx="84" cy="54" r="5" fill="#f2c230" />
        </g>
      ),
    },
    {
      id: 'clock', label: 'clock', at: [276, 56], box: [254, 34, 44, 44], art: clock(276, 56, 18),
    },
    {
      id: 'wardrobe', label: 'wardrobe', at: [352, 146], box: [306, 56, 90, 184], art: (
        <g>
          <rect x="312" y="60" width="80" height="170" rx="4" fill="#c9a27a" stroke="#9a7550" strokeWidth="3" />
          <line x1="352" y1="60" x2="352" y2="230" stroke="#9a7550" strokeWidth="3" />
          <rect x="342" y="130" width="5" height="22" rx="2" fill="#9a7550" />
          <rect x="357" y="130" width="5" height="22" rx="2" fill="#9a7550" />
          <rect x="316" y="230" width="8" height="6" fill="#9a7550" />
          <rect x="380" y="230" width="8" height="6" fill="#9a7550" />
        </g>
      ),
    },
    {
      id: 'bed', label: 'bed', at: [104, 196], box: [16, 116, 178, 138], art: (
        <g>
          <rect x="20" y="120" width="16" height="130" rx="4" fill="#a98a62" stroke="#86694a" strokeWidth="2" />
          <rect x="178" y="160" width="12" height="90" rx="4" fill="#a98a62" stroke="#86694a" strokeWidth="2" />
          <rect x="36" y="172" width="142" height="10" fill="#f4f1ea" stroke="#c9c2b4" strokeWidth="2" />
          <rect x="36" y="180" width="142" height="34" rx="3" fill="#8fb3d6" stroke="#6b8fb2" strokeWidth="2" />
          <rect x="36" y="214" width="142" height="12" fill="#a98a62" stroke="#86694a" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'pillow', label: 'pillow', at: [62, 168], box: [36, 154, 54, 30], art: (
        <rect x="40" y="158" width="46" height="22" rx="10" fill="#fbf8f2" stroke="#c9c2b4" strokeWidth="2" />
      ),
    },
    {
      id: 'teddy', label: 'teddy', at: [150, 156], box: [130, 124, 40, 56], art: (
        <g fill="#b5835a" stroke="#8a5f3c" strokeWidth="2">
          <circle cx="141" cy="134" r="5" />
          <circle cx="159" cy="134" r="5" />
          <ellipse cx="150" cy="164" rx="13" ry="14" />
          <circle cx="150" cy="142" r="10" />
          <ellipse cx="150" cy="146" rx="4" ry="3" fill="#e2c3a0" />
          <circle cx="146" cy="140" r="1.5" fill="#3a3a3a" stroke="none" />
          <circle cx="154" cy="140" r="1.5" fill="#3a3a3a" stroke="none" />
          <ellipse cx="137" cy="164" rx="4" ry="7" />
          <ellipse cx="163" cy="164" rx="4" ry="7" />
        </g>
      ),
    },
    {
      id: 'lamp', label: 'lamp', at: [225, 142], box: [202, 108, 46, 66], art: (
        <g>
          <ellipse cx="225" cy="170" rx="11" ry="3" fill="#8a7a66" />
          <rect x="223" y="138" width="4" height="32" fill="#8a7a66" />
          <polygon points="208,140 242,140 236,114 214,114" fill="#f2d58a" stroke="#c9a94e" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'rug', label: 'rug', at: [230, 272], box: [158, 254, 144, 36], art: (
        <g>
          <ellipse cx="230" cy="272" rx="70" ry="16" fill="#c99fb0" stroke="#a87d8f" strokeWidth="2" />
          <ellipse cx="230" cy="272" rx="52" ry="10" fill="none" stroke="#a87d8f" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'book', label: 'book', at: [274, 270], box: [252, 254, 44, 32], art: (
        <g>
          <path d="M256 268 Q265 262 274 266 Q283 262 292 268 L292 282 Q283 277 274 281 Q265 277 256 282 Z" fill="#c45a4f" stroke="#9c4239" strokeWidth="2" />
          <path d="M258 266 Q266 260 274 264 L274 278 Q266 274 258 279 Z" fill="#fbf8f2" stroke="#c9c2b4" strokeWidth="1.5" />
          <path d="M290 266 Q282 260 274 264 L274 278 Q282 274 290 279 Z" fill="#fbf8f2" stroke="#c9c2b4" strokeWidth="1.5" />
        </g>
      ),
    },
    {
      id: 'slippers', label: 'slippers', at: [92, 276], box: [62, 260, 62, 30], art: (
        <g fill="#7f9fc4" stroke="#5f7fa4" strokeWidth="2">
          <ellipse cx="80" cy="270" rx="15" ry="7" />
          <ellipse cx="86" cy="270" rx="7" ry="4" fill="#5f7fa4" />
          <ellipse cx="104" cy="282" rx="15" ry="7" />
          <ellipse cx="110" cy="282" rx="7" ry="4" fill="#5f7fa4" />
        </g>
      ),
    },
  ],
};

const bathroom: Scene = {
  id: 'bathroom',
  label: 'Bathroom',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="222" fill="#e3eef2" />
      <g stroke="#d0e0e7" strokeWidth="1.5">
        {[40, 80, 120, 160, 200].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}
        {[40, 80, 120, 160, 200, 240, 280, 320, 360].map((x) => <line key={x} x1={x} y1="0" x2={x} y2="222" />)}
      </g>
      <rect y="222" width="400" height="78" fill="#c9d3d6" />
      <g stroke="#b6c1c5" strokeWidth="1.5">{[248, 274].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}</g>
    </>
  ),
  parts: [
    {
      id: 'bath', label: 'bath', at: [90, 222], box: [4, 180, 174, 84], art: (
        <g>
          <path d="M14 196 L168 196 L162 240 Q158 252 146 252 L36 252 Q24 252 20 240 Z" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
          <rect x="8" y="186" width="166" height="10" rx="4" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
          <rect x="32" y="252" width="10" height="9" rx="2" fill="#a9b6bf" />
          <rect x="140" y="252" width="10" height="9" rx="2" fill="#a9b6bf" />
        </g>
      ),
    },
    {
      id: 'shower', label: 'shower', at: [80, 90], box: [54, 38, 52, 108], art: (
        <g>
          <path d="M96 142 L96 54 Q96 48 90 48 L78 48" fill="none" stroke="#8a96a3" strokeWidth="5" strokeLinecap="round" />
          <polygon points="66,52 88,52 94,66 60,66" fill="#a9b6bf" stroke="#7f8b96" strokeWidth="2" />
          <g stroke="#9cc4dc" strokeWidth="2" strokeLinecap="round">
            <line x1="66" y1="72" x2="64" y2="82" />
            <line x1="77" y1="72" x2="77" y2="84" />
            <line x1="88" y1="72" x2="90" y2="82" />
          </g>
        </g>
      ),
    },
    {
      id: 'mat', label: 'mat', at: [102, 279], box: [48, 264, 108, 30], art: (
        <g>
          <rect x="54" y="270" width="96" height="18" rx="6" fill="#9cc3a6" stroke="#779f82" strokeWidth="2" />
          <line x1="62" y1="279" x2="142" y2="279" stroke="#779f82" strokeWidth="2" strokeDasharray="4 4" />
        </g>
      ),
    },
    {
      id: 'mirror', label: 'mirror', at: [228, 64], box: [194, 24, 68, 82], art: (
        <g>
          <ellipse cx="228" cy="64" rx="30" ry="36" fill="#d9ecf3" stroke="#9aa9b3" strokeWidth="4" />
          <line x1="212" y1="52" x2="224" y2="38" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" />
        </g>
      ),
    },
    {
      id: 'sink', label: 'sink', at: [228, 180], box: [178, 144, 100, 96], art: (
        <g>
          <path d="M216 174 L240 174 L236 236 L220 236 Z" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
          <path d="M182 150 L274 150 Q270 176 228 178 Q186 176 182 150 Z" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'tap', label: 'tap', at: [230, 138], box: [214, 120, 32, 32], art: (
        <g fill="none" stroke="#8a96a3" strokeWidth="5" strokeLinecap="round">
          <path d="M222 150 L222 132 Q222 127 228 127 L234 127 Q240 127 240 134" />
        </g>
      ),
    },
    {
      id: 'toothbrush', label: 'toothbrush', at: [196, 130], box: [182, 104, 30, 48], art: (
        <g>
          <line x1="196" y1="138" x2="202" y2="112" stroke="#4d8fc4" strokeWidth="4" strokeLinecap="round" />
          <rect x="200" y="108" width="7" height="10" rx="2" fill="#ffffff" stroke="#4d8fc4" strokeWidth="2" />
          <path d="M187 132 L205 132 L203 150 L189 150 Z" fill="#e8b8c8" stroke="#c493a5" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'soap', label: 'soap', at: [260, 144], box: [246, 128, 32, 26], art: (
        <rect x="250" y="139" width="22" height="11" rx="5" fill="#f2c4d6" stroke="#c999ad" strokeWidth="2" />
      ),
    },
    {
      id: 'towel', label: 'towel', at: [302, 114], box: [278, 76, 48, 74], art: (
        <g>
          <line x1="280" y1="84" x2="324" y2="84" stroke="#8a96a3" strokeWidth="4" strokeLinecap="round" />
          <rect x="286" y="84" width="32" height="62" rx="3" fill="#e7a26b" stroke="#c47f4a" strokeWidth="2" />
          <line x1="286" y1="134" x2="318" y2="134" stroke="#c47f4a" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'toilet', label: 'toilet', at: [362, 190], box: [324, 124, 72, 122], art: (
        <g>
          <rect x="350" y="130" width="40" height="42" rx="4" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
          <rect x="370" y="136" width="10" height="5" rx="2" fill="#a9b6bf" />
          <path d="M332 184 L390 184 Q388 208 366 212 L366 240 L346 240 L348 210 Q334 204 332 184 Z" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
          <rect x="328" y="176" width="64" height="8" rx="3" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'roll', label: 'toilet roll', at: [306, 190], box: [290, 172, 34, 36], art: (
        <g>
          <rect x="308" y="186" width="8" height="18" fill="#fdfcf8" stroke="#b8b2a6" strokeWidth="1.5" />
          <circle cx="306" cy="186" r="10" fill="#fdfcf8" stroke="#b8b2a6" strokeWidth="2" />
          <circle cx="306" cy="186" r="3" fill="#c9c2b4" />
        </g>
      ),
    },
  ],
};

const livingroom: Scene = {
  id: 'livingroom',
  label: 'Living room',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="232" fill="#efe6d8" />
      <rect y="232" width="400" height="68" fill="#c8a984" />
      <g stroke="#b39270" strokeWidth="1.5">{[252, 276].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}</g>
      <rect y="226" width="400" height="6" fill="#ddd0bc" />
      <rect x="288" y="184" width="96" height="52" rx="3" fill="#b98a5c" stroke="#8f6a45" strokeWidth="2" />
      <line x1="336" y1="184" x2="336" y2="236" stroke="#8f6a45" strokeWidth="2" />
      <rect x="331" y="174" width="10" height="10" fill="#4a4f57" />
    </>
  ),
  parts: [
    {
      id: 'lamp', label: 'lamp', at: [26, 170], box: [4, 92, 46, 156], art: (
        <g>
          <ellipse cx="26" cy="242" rx="14" ry="4" fill="#6f6a62" />
          <rect x="24" y="124" width="4" height="118" fill="#6f6a62" />
          <polygon points="8,126 44,126 38,98 14,98" fill="#f2d58a" stroke="#c9a94e" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'sofa', label: 'sofa', at: [134, 190], box: [48, 134, 172, 108], art: (
        <g fill="#7fa38c" stroke="#5e8069" strokeWidth="3">
          <rect x="58" y="140" width="152" height="60" rx="10" />
          <rect x="64" y="196" width="140" height="24" rx="6" />
          <rect x="52" y="172" width="20" height="56" rx="8" />
          <rect x="196" y="172" width="20" height="56" rx="8" />
          <rect x="66" y="228" width="8" height="10" fill="#5e8069" />
          <rect x="194" y="228" width="8" height="10" fill="#5e8069" />
        </g>
      ),
    },
    {
      id: 'cushion', label: 'cushion', at: [94, 177], box: [68, 152, 52, 48], art: (
        <rect x="74" y="158" width="40" height="38" rx="9" fill="#e3b26a" stroke="#b98a45" strokeWidth="2" />
      ),
    },
    {
      id: 'picture', label: 'picture', at: [137, 74], box: [98, 42, 78, 64], art: (
        <g>
          <rect x="104" y="48" width="66" height="52" fill="#f6efe0" stroke="#8a6a4a" strokeWidth="4" />
          <path d="M108 96 L128 70 L142 84 L150 76 L166 96 Z" fill="#7fae7f" />
          <circle cx="152" cy="62" r="6" fill="#f2c230" />
        </g>
      ),
    },
    {
      id: 'window', label: 'window', at: [258, 68], box: [218, 28, 80, 80], art: (
        <g>
          <rect x="222" y="32" width="72" height="72" rx="3" fill="#cfe8f7" stroke="#9c8a74" strokeWidth="5" />
          <line x1="258" y1="32" x2="258" y2="104" stroke="#9c8a74" strokeWidth="4" />
          <line x1="222" y1="68" x2="294" y2="68" stroke="#9c8a74" strokeWidth="4" />
        </g>
      ),
    },
    {
      id: 'clock', label: 'clock', at: [344, 54], box: [324, 34, 40, 40], art: clock(344, 54, 16),
    },
    {
      id: 'plant', label: 'plant', at: [248, 196], box: [222, 146, 52, 100], art: (
        <g>
          <g fill="#7fae7f" stroke="#5e8c5e" strokeWidth="2">
            <path d="M248 206 Q228 186 226 160 Q244 172 248 206 Z" />
            <path d="M248 206 Q268 186 270 160 Q252 172 248 206 Z" />
            <path d="M248 206 Q238 176 248 150 Q258 176 248 206 Z" />
          </g>
          <path d="M232 204 L264 204 L260 242 L236 242 Z" fill="#c7845a" stroke="#a0653f" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'tv', label: 'television', at: [334, 143], box: [280, 106, 108, 74], art: (
        <g>
          <rect x="284" y="112" width="100" height="62" rx="4" fill="#3d4650" stroke="#2a3038" strokeWidth="3" />
          <rect x="290" y="118" width="88" height="50" rx="2" fill="#56616d" />
        </g>
      ),
    },
    {
      id: 'rug', label: 'rug', at: [300, 276], box: [212, 258, 176, 36], art: (
        <g>
          <ellipse cx="300" cy="276" rx="84" ry="15" fill="#b7c6d9" stroke="#8ea2ba" strokeWidth="2" />
          <ellipse cx="300" cy="276" rx="64" ry="9" fill="none" stroke="#8ea2ba" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'table', label: 'table', at: [140, 266], box: [84, 248, 112, 44], art: (
        <g>
          <rect x="88" y="254" width="104" height="9" rx="3" fill="#a8713f" stroke="#8a5a33" strokeWidth="2" />
          <rect x="96" y="263" width="7" height="26" fill="#8a5a33" />
          <rect x="177" y="263" width="7" height="26" fill="#8a5a33" />
        </g>
      ),
    },
    {
      id: 'remote', label: 'remote', at: [140, 249], box: [120, 236, 40, 22], art: (
        <g>
          <rect x="126" y="246" width="30" height="8" rx="3" fill="#4a4f57" stroke="#2f3338" strokeWidth="1.5" />
          <circle cx="132" cy="250" r="1.8" fill="#d8473b" />
          <circle cx="140" cy="250" r="1.5" fill="#c9ced4" />
          <circle cx="146" cy="250" r="1.5" fill="#c9ced4" />
        </g>
      ),
    },
  ],
};

const classroom: Scene = {
  id: 'classroom',
  label: 'Classroom',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="236" fill="#eef0e6" />
      <rect y="236" width="400" height="64" fill="#cfc3a8" />
      <g stroke="#bdb096" strokeWidth="1.5">{[256, 278].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}</g>
      <rect y="230" width="400" height="6" fill="#d9dccf" />
    </>
  ),
  parts: [
    {
      id: 'board', label: 'board', at: [110, 86], box: [14, 34, 192, 106], art: (
        <g>
          <rect x="20" y="40" width="180" height="90" rx="3" fill="#3f6b55" stroke="#8a6a4a" strokeWidth="5" />
          <rect x="30" y="130" width="160" height="5" rx="2" fill="#8a6a4a" />
          <g fill="none" stroke="#dfe8e1" strokeWidth="2.5" strokeLinecap="round">
            <circle cx="60" cy="80" r="14" />
            <path d="M96 94 L112 64 L128 94 Z" />
            <rect x="146" y="66" width="28" height="28" />
          </g>
          <rect x="150" y="125" width="12" height="5" rx="2" fill="#f4f1ea" />
        </g>
      ),
    },
    {
      id: 'clock', label: 'clock', at: [240, 52], box: [218, 30, 44, 44], art: clock(240, 52, 18),
    },
    {
      id: 'window', label: 'window', at: [336, 54], box: [286, 18, 100, 74], art: (
        <g>
          <rect x="290" y="22" width="92" height="64" rx="3" fill="#cfe8f7" stroke="#9c8a74" strokeWidth="5" />
          <line x1="336" y1="22" x2="336" y2="86" stroke="#9c8a74" strokeWidth="4" />
          <line x1="290" y1="54" x2="382" y2="54" stroke="#9c8a74" strokeWidth="4" />
        </g>
      ),
    },
    {
      id: 'cupboard', label: 'cupboard', at: [345, 186], box: [296, 136, 98, 100], art: (
        <g>
          <rect x="300" y="140" width="90" height="92" rx="3" fill="#c9a27a" stroke="#9a7550" strokeWidth="3" />
          <line x1="345" y1="140" x2="345" y2="232" stroke="#9a7550" strokeWidth="3" />
          <rect x="336" y="176" width="4" height="18" rx="2" fill="#9a7550" />
          <rect x="350" y="176" width="4" height="18" rx="2" fill="#9a7550" />
        </g>
      ),
    },
    {
      id: 'globe', label: 'globe', at: [345, 114], box: [322, 90, 46, 52], art: (
        <g>
          <rect x="334" y="134" width="22" height="6" rx="2" fill="#8a7a66" />
          <line x1="345" y1="134" x2="345" y2="130" stroke="#8a7a66" strokeWidth="3" />
          <circle cx="345" cy="112" r="18" fill="#8cc1e0" stroke="#5d93b5" strokeWidth="2" />
          <path d="M334 100 Q342 98 344 106 Q340 112 334 110 Z" fill="#7fae7f" />
          <path d="M348 112 Q358 108 360 116 Q356 126 348 122 Z" fill="#7fae7f" />
          <path d="M327 112 Q345 108 363 112" fill="none" stroke="#5d93b5" strokeWidth="1.5" />
        </g>
      ),
    },
    {
      id: 'desk', label: 'desk', at: [180, 230], box: [106, 184, 148, 90], art: (
        <g>
          <rect x="110" y="190" width="140" height="10" rx="2" fill="#c9a27a" stroke="#9a7550" strokeWidth="2" />
          <rect x="118" y="200" width="6" height="70" fill="#7f8b96" />
          <rect x="236" y="200" width="6" height="70" fill="#7f8b96" />
        </g>
      ),
    },
    {
      id: 'book', label: 'book', at: [150, 182], box: [124, 166, 52, 26], art: (
        <g>
          <path d="M130 186 Q140 179 150 183 Q160 179 170 186 L170 190 L130 190 Z" fill="#4d7fb5" stroke="#375f8a" strokeWidth="2" />
          <path d="M132 184 Q141 176 150 180 L150 188 Q141 184 132 188 Z" fill="#fbf8f2" stroke="#c9c2b4" strokeWidth="1.5" />
          <path d="M168 184 Q159 176 150 180 L150 188 Q159 184 168 188 Z" fill="#fbf8f2" stroke="#c9c2b4" strokeWidth="1.5" />
        </g>
      ),
    },
    {
      id: 'pencil', label: 'pencil', at: [216, 186], box: [188, 172, 56, 24], art: (
        <g>
          <rect x="196" y="182" width="34" height="7" fill="#f2c230" stroke="#c79e1f" strokeWidth="1.5" />
          <polygon points="230,182 241,185.5 230,189" fill="#e8c9a0" stroke="#c79e1f" strokeWidth="1.5" />
          <rect x="191" y="182" width="6" height="7" rx="1" fill="#e39a9a" />
        </g>
      ),
    },
    {
      id: 'chair', label: 'chair', at: [68, 226], box: [38, 162, 60, 124], art: (
        <g fill="#e08a5a" stroke="#b56a3f" strokeWidth="2">
          <rect x="44" y="168" width="8" height="66" rx="2" />
          <rect x="44" y="230" width="48" height="8" rx="2" />
          <rect x="46" y="238" width="6" height="44" />
          <rect x="84" y="238" width="6" height="44" />
        </g>
      ),
    },
    {
      id: 'bag', label: 'bag', at: [282, 256], box: [256, 222, 52, 64], art: (
        <g>
          <path d="M272 238 Q272 226 282 226 Q292 226 292 238" fill="none" stroke="#375f8a" strokeWidth="4" />
          <rect x="262" y="236" width="40" height="46" rx="8" fill="#4d7fb5" stroke="#375f8a" strokeWidth="2" />
          <path d="M262 248 Q282 260 302 248" fill="none" stroke="#375f8a" strokeWidth="2" />
          <rect x="272" y="262" width="20" height="12" rx="3" fill="#6a96c6" stroke="#375f8a" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'bin', label: 'bin', at: [354, 266], box: [330, 240, 48, 52], art: (
        <g>
          <path d="M336 246 L372 246 L368 288 L340 288 Z" fill="#7f8b96" stroke="#5c6670" strokeWidth="2" />
          <line x1="346" y1="254" x2="347" y2="282" stroke="#5c6670" strokeWidth="2" />
          <line x1="362" y1="254" x2="361" y2="282" stroke="#5c6670" strokeWidth="2" />
        </g>
      ),
    },
  ],
};

const supermarket: Scene = {
  id: 'supermarket',
  label: 'Supermarket',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="214" fill="#eef0ea" />
      <rect y="214" width="400" height="86" fill="#d8d6cc" />
      <g stroke="#c4c2b6" strokeWidth="1.5">
        {[236, 262].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}
        {[60, 140, 220, 300, 380].map((x) => <line key={x} x1={x} y1="214" x2={x} y2="300" />)}
      </g>
      <rect x="290" y="172" width="104" height="66" rx="3" fill="#a9b6c2" stroke="#7f8d99" strokeWidth="2" />
      <rect x="290" y="172" width="104" height="8" fill="#4a4f57" />
    </>
  ),
  parts: [
    {
      id: 'shelf', label: 'shelf', at: [125, 120], box: [12, 28, 226, 188], art: (
        <g fill="#a9b6c2" stroke="#7f8d99" strokeWidth="2">
          <rect x="16" y="30" width="8" height="182" />
          <rect x="226" y="30" width="8" height="182" />
          <rect x="16" y="80" width="218" height="7" />
          <rect x="16" y="140" width="218" height="7" />
          <rect x="16" y="200" width="218" height="7" />
        </g>
      ),
    },
    {
      id: 'bananas', label: 'bananas', at: [56, 66], box: [28, 46, 58, 36], art: (
        <g fill="#f2d058" stroke="#c9a92e" strokeWidth="2">
          <path d="M34 60 Q40 80 72 78 Q76 74 72 72 Q48 74 40 58 Z" />
          <path d="M38 54 Q50 74 78 70 Q80 66 76 65 Q54 66 44 52 Z" />
          <path d="M44 50 Q58 66 82 62 Q84 58 80 57 Q60 58 50 48 Z" />
          <rect x="34" y="50" width="12" height="6" rx="2" fill="#8a7a3c" stroke="none" />
        </g>
      ),
    },
    {
      id: 'apples', label: 'apples', at: [120, 66], box: [94, 46, 54, 36], art: (
        <g fill="#d8473b" stroke="#a83a31" strokeWidth="2">
          <circle cx="106" cy="72" r="8" />
          <circle cx="122" cy="72" r="8" />
          <circle cx="138" cy="72" r="8" />
          <circle cx="114" cy="58" r="8" />
          <circle cx="130" cy="58" r="8" />
          <line x1="114" y1="50" x2="115" y2="46" stroke="#6b5a3a" />
          <line x1="130" y1="50" x2="131" y2="46" stroke="#6b5a3a" />
        </g>
      ),
    },
    {
      id: 'carrots', label: 'carrots', at: [194, 66], box: [162, 48, 66, 34], art: (
        <g>
          <g fill="#e8893a" stroke="#c46a26" strokeWidth="2">
            <polygon points="176,58 220,62 176,66" />
            <polygon points="176,66 218,70 176,74" />
            <polygon points="176,74 220,78 176,79" />
          </g>
          <g stroke="#5e8c5e" strokeWidth="3" strokeLinecap="round">
            <line x1="176" y1="62" x2="166" y2="56" />
            <line x1="176" y1="70" x2="166" y2="68" />
            <line x1="176" y1="76" x2="167" y2="78" />
          </g>
        </g>
      ),
    },
    {
      id: 'bread', label: 'bread', at: [60, 124], box: [24, 104, 72, 40], art: (
        <g>
          <path d="M30 140 L30 124 Q30 110 60 110 Q90 110 90 124 L90 140 Z" fill="#d9a35f" stroke="#b07c3c" strokeWidth="2" />
          <g stroke="#b07c3c" strokeWidth="2" strokeLinecap="round">
            <line x1="46" y1="116" x2="42" y2="124" />
            <line x1="60" y1="115" x2="56" y2="123" />
            <line x1="74" y1="116" x2="70" y2="124" />
          </g>
        </g>
      ),
    },
    {
      id: 'milk', label: 'milk', at: [133, 120], box: [106, 98, 54, 46], art: (
        <g>
          {[112, 136].map((x) => (
            <g key={x}>
              <path d={`M${x} 140 L${x} 116 Q${x} 110 ${x + 5} 108 L${x + 5} 104 L${x + 13} 104 L${x + 13} 108 Q${x + 18} 110 ${x + 18} 116 L${x + 18} 140 Z`} fill="#ffffff" stroke="#9aa9b3" strokeWidth="2" />
              <rect x={x + 4} y="100" width="10" height="5" rx="1" fill="#2f74c8" />
              <rect x={x} y="122" width="18" height="8" fill="#9cc4e8" />
            </g>
          ))}
        </g>
      ),
    },
    {
      id: 'cheese', label: 'cheese', at: [198, 126], box: [168, 108, 62, 36], art: (
        <g>
          <polygon points="176,140 222,140 222,120 176,132" fill="#f2c94c" stroke="#c9a12e" strokeWidth="2" />
          <circle cx="196" cy="134" r="3" fill="#d9ad32" />
          <circle cx="210" cy="129" r="2.5" fill="#d9ad32" />
          <circle cx="214" cy="136" r="2" fill="#d9ad32" />
        </g>
      ),
    },
    {
      id: 'eggs', label: 'eggs', at: [62, 188], box: [24, 168, 78, 36], art: (
        <g>
          {[38, 54, 70, 86].map((x) => <ellipse key={x} cx={x} cy="184" rx="7" ry="9" fill="#f4e6cf" stroke="#c9b48f" strokeWidth="2" />)}
          <rect x="28" y="188" width="68" height="12" rx="2" fill="#b9ad98" stroke="#93876f" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'tins', label: 'tins', at: [164, 186], box: [124, 166, 82, 38], art: (
        <g>
          {[132, 156, 180].map((x) => (
            <g key={x}>
              <rect x={x} y="174" width="20" height="26" rx="2" fill="#c9ced4" stroke="#8f9aa4" strokeWidth="2" />
              <rect x={x} y="180" width="20" height="13" fill="#d8473b" />
            </g>
          ))}
        </g>
      ),
    },
    {
      id: 'trolley', label: 'trolley', at: [206, 248], box: [144, 202, 128, 90], art: (
        <g fill="none" stroke="#7f8d99" strokeWidth="3" strokeLinejoin="round">
          <polygon points="150,214 256,214 246,256 162,256" fill="#e1e6ea" />
          <g strokeWidth="1.5">
            <line x1="178" y1="214" x2="182" y2="256" />
            <line x1="204" y1="214" x2="204" y2="256" />
            <line x1="230" y1="214" x2="226" y2="256" />
            <line x1="154" y1="235" x2="252" y2="235" />
          </g>
          <line x1="256" y1="214" x2="268" y2="206" strokeLinecap="round" />
          <line x1="164" y1="256" x2="168" y2="274" />
          <line x1="244" y1="256" x2="240" y2="274" />
          <line x1="160" y1="270" x2="248" y2="270" />
          <circle cx="170" cy="282" r="7" fill="#4a4f57" stroke="#2f3338" />
          <circle cx="238" cy="282" r="7" fill="#4a4f57" stroke="#2f3338" />
        </g>
      ),
    },
    {
      id: 'basket', label: 'basket', at: [66, 262], box: [26, 230, 80, 60], art: (
        <g>
          <path d="M46 252 Q46 234 66 234 Q86 234 86 252" fill="none" stroke="#a84f46" strokeWidth="4" />
          <path d="M30 250 L102 250 L94 286 L38 286 Z" fill="#d46a5f" stroke="#a84f46" strokeWidth="2" />
          <g stroke="#a84f46" strokeWidth="1.5">
            <line x1="34" y1="262" x2="98" y2="262" />
            <line x1="36" y1="274" x2="96" y2="274" />
            <line x1="56" y1="250" x2="58" y2="286" />
            <line x1="76" y1="250" x2="74" y2="286" />
          </g>
        </g>
      ),
    },
    {
      id: 'till', label: 'till', at: [346, 146], box: [316, 112, 62, 62], art: (
        <g>
          <rect x="344" y="140" width="6" height="12" fill="#4d5763" />
          <rect x="330" y="118" width="34" height="24" rx="2" fill="#cfe3ea" stroke="#4d5763" strokeWidth="2" />
          <rect x="322" y="150" width="50" height="22" rx="3" fill="#6f7a86" stroke="#4d5763" strokeWidth="2" />
          <g fill="#c9ced4">
            {[328, 336, 344].map((x) => <rect key={x} x={x} y="155" width="5" height="4" rx="1" />)}
            {[328, 336, 344].map((x) => <rect key={x} x={x} y="162" width="5" height="4" rx="1" />)}
          </g>
          <rect x="354" y="156" width="12" height="10" rx="1" fill="#4d5763" />
        </g>
      ),
    },
  ],
};

const doctors: Scene = {
  id: 'doctors',
  label: "Doctor's surgery",
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="222" fill="#e8f0ee" />
      <rect y="222" width="400" height="78" fill="#c9cfc6" />
      <g stroke="#b6bdb3" strokeWidth="1.5">{[246, 272].map((y) => <line key={y} x1="0" y1={y} x2="400" y2={y} />)}</g>
      <rect y="216" width="400" height="6" fill="#d6dfdc" />
      <line x1="84" y1="94" x2="140" y2="94" stroke="#9a7550" strokeWidth="4" strokeLinecap="round" />
    </>
  ),
  parts: [
    {
      id: 'door', label: 'door', at: [39, 134], box: [6, 42, 66, 184], art: (
        <g>
          <rect x="12" y="48" width="54" height="174" rx="2" fill="#b8916a" stroke="#8f6d4b" strokeWidth="3" />
          <rect x="20" y="58" width="38" height="64" rx="2" fill="none" stroke="#8f6d4b" strokeWidth="2" />
          <rect x="20" y="146" width="38" height="64" rx="2" fill="none" stroke="#8f6d4b" strokeWidth="2" />
          <circle cx="58" cy="136" r="4" fill="#e3c27a" stroke="#8f6d4b" strokeWidth="1.5" />
        </g>
      ),
    },
    {
      id: 'plasters', label: 'plasters', at: [112, 78], box: [86, 58, 52, 36], art: (
        <g>
          <rect x="92" y="66" width="40" height="26" rx="3" fill="#f4ece0" stroke="#c47f4a" strokeWidth="2" />
          <rect x="99" y="74" width="26" height="10" rx="5" fill="#e3b58e" stroke="#c4936a" strokeWidth="1.5" />
          <rect x="107" y="75" width="10" height="8" rx="1" fill="#f4ddc6" />
        </g>
      ),
    },
    {
      id: 'sink', label: 'sink', at: [112, 142], box: [74, 108, 76, 78], art: (
        <g>
          <rect x="109" y="156" width="6" height="26" fill="#a9b6bf" />
          <path d="M80 134 L144 134 Q140 158 112 160 Q84 158 80 134 Z" fill="#fbfbf8" stroke="#a9b6bf" strokeWidth="3" />
          <path d="M106 134 L106 120 Q106 115 112 115 L118 115 Q123 115 123 121" fill="none" stroke="#8a96a3" strokeWidth="4" strokeLinecap="round" />
        </g>
      ),
    },
    {
      id: 'window', label: 'window', at: [204, 72], box: [164, 32, 80, 80], art: (
        <g>
          <rect x="168" y="36" width="72" height="72" rx="3" fill="#cfe8f7" stroke="#9c8a74" strokeWidth="5" />
          <line x1="204" y1="36" x2="204" y2="108" stroke="#9c8a74" strokeWidth="4" />
          <line x1="168" y1="72" x2="240" y2="72" stroke="#9c8a74" strokeWidth="4" />
        </g>
      ),
    },
    {
      id: 'stethoscope', label: 'stethoscope', at: [268, 90], box: [248, 44, 42, 94], art: (
        <g>
          <circle cx="268" cy="52" r="3" fill="#8a7a66" />
          <g fill="none" stroke="#4a5563" strokeWidth="3" strokeLinecap="round">
            <path d="M258 62 Q258 54 268 54 Q278 54 278 62" />
            <path d="M258 62 Q258 84 268 96" />
            <path d="M278 62 Q278 84 268 96" />
            <path d="M268 96 Q268 116 274 122" />
          </g>
          <circle cx="258" cy="62" r="2.5" fill="#4a5563" />
          <circle cx="278" cy="62" r="2.5" fill="#4a5563" />
          <circle cx="276" cy="128" r="7" fill="#a9b6bf" stroke="#6f7a86" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'bed', label: 'bed', at: [206, 196], box: [146, 156, 120, 88], art: (
        <g>
          <rect x="160" y="200" width="5" height="40" fill="#8f9aa4" />
          <rect x="248" y="200" width="5" height="40" fill="#8f9aa4" />
          <rect x="154" y="194" width="104" height="7" rx="2" fill="#a9b6bf" stroke="#8f9aa4" strokeWidth="1.5" />
          <rect x="150" y="180" width="112" height="14" rx="4" fill="#9fc7b8" stroke="#6f9d8c" strokeWidth="2" />
          <polygon points="150,182 152,162 180,170 180,182" fill="#9fc7b8" stroke="#6f9d8c" strokeWidth="2" strokeLinejoin="round" />
          <rect x="182" y="179" width="76" height="4" fill="#fbfbf8" />
        </g>
      ),
    },
    {
      id: 'chair', label: 'chair', at: [282, 206], box: [260, 154, 42, 102], art: (
        <g fill="#6f8fb0" stroke="#4f6f90" strokeWidth="2">
          <rect x="266" y="160" width="7" height="58" rx="2" />
          <rect x="266" y="212" width="34" height="7" rx="2" />
          <rect x="268" y="219" width="5" height="32" />
          <rect x="292" y="219" width="5" height="32" />
        </g>
      ),
    },
    {
      id: 'desk', label: 'desk', at: [346, 204], box: [296, 164, 100, 80], art: (
        <g>
          <rect x="300" y="170" width="92" height="8" rx="2" fill="#c9a27a" stroke="#9a7550" strokeWidth="2" />
          <rect x="304" y="178" width="6" height="62" fill="#9a7550" />
          <rect x="350" y="178" width="40" height="62" fill="#c9a27a" stroke="#9a7550" strokeWidth="2" />
          <line x1="350" y1="208" x2="390" y2="208" stroke="#9a7550" strokeWidth="2" />
          <rect x="364" y="190" width="12" height="4" rx="2" fill="#9a7550" />
          <rect x="364" y="220" width="12" height="4" rx="2" fill="#9a7550" />
        </g>
      ),
    },
    {
      id: 'computer', label: 'computer', at: [346, 138], box: [312, 106, 68, 66], art: (
        <g>
          <rect x="342" y="152" width="8" height="12" fill="#4a4f57" />
          <rect x="332" y="163" width="28" height="6" rx="2" fill="#4a4f57" />
          <rect x="318" y="112" width="56" height="40" rx="3" fill="#3d4650" stroke="#2a3038" strokeWidth="3" />
          <rect x="323" y="117" width="46" height="30" rx="1" fill="#cfe3ea" />
        </g>
      ),
    },
    {
      id: 'scales', label: 'scales', at: [208, 272], box: [180, 248, 56, 46], art: (
        <g>
          <rect x="186" y="254" width="44" height="36" rx="8" fill="#e6eaee" stroke="#8f9aa4" strokeWidth="2.5" />
          <rect x="198" y="259" width="20" height="9" rx="2" fill="#3d4650" />
          <rect x="201" y="262" width="10" height="3" fill="#9fd4b0" />
          <rect x="192" y="272" width="13" height="13" rx="4" fill="#cfd5db" />
          <rect x="211" y="272" width="13" height="13" rx="4" fill="#cfd5db" />
        </g>
      ),
    },
    {
      id: 'plant', label: 'plant', at: [40, 258], box: [16, 222, 52, 72], art: (
        <g>
          <g fill="#7fae7f" stroke="#5e8c5e" strokeWidth="2">
            <path d="M40 264 Q22 248 20 228 Q36 238 40 264 Z" />
            <path d="M40 264 Q58 248 60 228 Q44 238 40 264 Z" />
            <path d="M40 264 Q32 244 40 224 Q48 244 40 264 Z" />
          </g>
          <path d="M26 262 L54 262 L50 292 L30 292 Z" fill="#c7845a" stroke="#a0653f" strokeWidth="2" />
        </g>
      ),
    },
  ],
};

export const INDOORS: Scene[] = [bedroom, bathroom, livingroom, classroom, supermarket, doctors];
